import { Deck, DeckCard, DeckCardTagType } from "@apiserver-rest/ponder-data-client-base";
import { DeckGroup } from "@ponder-features/user/decks/deck/group/deck-group";
import { environment } from "../../../../../environments/environment";

export class MagicDeckGroupSignatureSpells extends DeckGroup {
    public constructor() {
        super("Signature Spell", `${environment.ponderImageBaseUrl}/magic/set/v10.svg`);
    }
    
    public override isValid(deck: Deck, card: DeckCard): boolean {
        return (card.tag == DeckCardTagType.SignatureSpell);
    }
}